import { timer } from "rxjs";
import { distinctUntilChanged, mergeMap } from "rxjs/operators";

import { requestHostInfo, requestHostTitle, requestHostUrl } from "../utils/parentWindowConnection";

export const reportUrlJob = () => {
    return timer(1000, 1000 * 10).pipe(
        mergeMap((_) => requestHostUrl()),
        distinctUntilChanged()
    );
};

export const reportInfoJob = () => {
    return timer(1000, 1000 * 60).pipe(
        mergeMap((_) => requestHostInfo()),
        distinctUntilChanged()
    );
};



// WEBPACK FOOTER //
// ./src/jobs/reportUrlJob.js